(() => {
  const initToggleWrappers = (root) => {
    if (!root) return;
    root.querySelectorAll('.toggle-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.toggleInitialized === 'true') return;
      wrapper.dataset.toggleInitialized = 'true';

      const moreBtn = wrapper.querySelector('.icon-more');
      const lessBtn = wrapper.querySelector('.icon-less');
      const desc = wrapper.querySelector('.text-open__item-description');
      const img = wrapper.querySelector('.text-open__image');

      if (!moreBtn || !lessBtn || !desc) return;

      const updateState = () => {
        const isOpen = desc.classList.toggle('is-open');
        desc.classList.toggle('is-closed', !isOpen);

        moreBtn.classList.toggle('hidden', isOpen);
        lessBtn.classList.toggle('hidden', !isOpen);
        if (img) img.classList.toggle('expanded', isOpen);
      };

      moreBtn.addEventListener('click', updateState);
      lessBtn.addEventListener('click', updateState);
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.brandModelSearchInitialized === 'true') return;
    section.dataset.brandModelSearchInitialized = 'true';

    const brandInputs = section.querySelectorAll('[data-brand-input]');
    const nextButton = section.querySelector('[data-brand-next]');
    const backButton = section.querySelector('[data-brand-back]');
    const summaryLabel = section.querySelector('[data-brand-summary]');
    const brandSelect = section.querySelector('[data-brand-select]');
    const brandPanels = section.querySelectorAll('[data-brand-panel]');
    const initialSummaryText = summaryLabel ? summaryLabel.textContent : '';

    const getSelectedInput = () => section.querySelector('[data-brand-input]:checked');

    const getSelectedBrand = () => {
      const checked = getSelectedInput();
      return checked ? checked.value : '';
    };

    const getSelectedBrandBlockId = () => {
      const checked = getSelectedInput();
      return checked ? checked.dataset.brandBlockId : '';
    };

    const getActivePanel = () => {
      const blockId = getSelectedBrandBlockId();
      if (!blockId) return null;
      return section.querySelector(`[data-brand-panel="${blockId}"]`);
    };

    const getActiveForm = () => {
      const panel = getActivePanel();
      return panel ? panel.querySelector('[data-brand-form]') : null;
    };

    const updateBrandPanel = () => {
      const blockId = getSelectedBrandBlockId();

      brandPanels.forEach((panel) => {
        const isActive = panel.dataset.brandPanel === blockId;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      if (blockId) {
        const activePanel = getActivePanel();
        if (activePanel) initToggleWrappers(activePanel);
      }
    };

    const updateNextState = () => {
      if (!nextButton) return;
      nextButton.disabled = !getSelectedBrand();
    };

    const goToStep = (step) => {
      section.dataset.activeStep = String(step);
    };

    const updateSelectedBrand = () => {
      const brand = getSelectedBrand();
      if (summaryLabel) {
        summaryLabel.textContent = brand || 'Escolha a marca abaixo';
      }

      section.querySelectorAll('[data-brand-panel] [data-selected-brand]').forEach((el) => {
        el.textContent = brand || '—';
      });
    };

    const resetState = () => {
      brandInputs.forEach((input) => {
        input.checked = false;
      });

      section.querySelectorAll('[data-model-input]').forEach((input) => {
        input.value = '';
      });
      section.querySelectorAll('[data-query-input]').forEach((input) => {
        input.value = '';
      });

      if (brandSelect) brandSelect.open = false;

      brandPanels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove('is-active');
      });

      goToStep(1);

      if (summaryLabel) {
        summaryLabel.textContent = initialSummaryText || 'Escolha a marca abaixo';
      }

      updateNextState();
    };

    brandInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateNextState();
        updateSelectedBrand();
        updateBrandPanel();
        if (brandSelect) {
          brandSelect.open = false;
        }
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        updateSelectedBrand();
        updateBrandPanel();
        goToStep(2);
        const activeForm = getActiveForm();
        const modelInput = activeForm ? activeForm.querySelector('[data-model-input]') : null;
        if (modelInput) modelInput.focus();
      });
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        goToStep(1);
        updateNextState();
      });
    }

    window.addEventListener('pageshow', (event) => {
      const navigation = performance.getEntriesByType('navigation')[0];
      const isBackForward = navigation?.type === 'back_forward';
      if (event.persisted || isBackForward) {
        resetState();
      }
    });

    section.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.matches('[data-brand-form]')) return;

      const panel = form.closest('[data-brand-panel]');
      if (!panel || panel.hidden) return;

      const brand = getSelectedBrand();
      const modelInput = form.querySelector('[data-model-input]');
      const queryInput = form.querySelector('[data-query-input]');
      const model = modelInput ? modelInput.value.trim() : '';

      if (!brand || !model) {
        event.preventDefault();
        updateNextState();
        return;
      }

      if (queryInput) {
        queryInput.value = model;

      }
    });

    updateNextState();
    updateSelectedBrand();
    updateBrandPanel();
  };

  const initAll = () => {
    document.querySelectorAll('[data-brand-model-search]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target) return;
    const section = target.matches?.('[data-brand-model-search]')
      ? target
      : target.querySelector?.('[data-brand-model-search]');
    if (section) initSection(section);
  });
})();
